import { useUser } from "../useUser";
import { useFetchWorkspaceMember } from "../../api/workspace-member.api";

export function useCurrentUserWorkspaceMember() {
    const user = useUser();
    const member = useFetchWorkspaceMember(user.id);

    return member.data ?? null;
}
